// extracted by mini-css-extract-plugin
export default {"wrapper":"GradesView_wrapper__55wcd","likeAnimation":"GradesView_likeAnimation__+I3YL"};